<template>
  <v-container grid-list-md :style="$vuetify.breakpoint.xl ? 'max-width: 70%' : $vuetify.breakpoint.smAndDown ? 'max-width: 95%' : ''">
    <v-layout wrap>
      <v-flex xs12 v-if="$vuetify.breakpoint.mdAndUp">
        <v-responsive :aspect-ratio="16 / 9" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="mossoo" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>
      <v-flex xs12 v-if="$vuetify.breakpoint.smAndDown">
        <v-responsive :aspect-ratio="9 / 16" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="mossoo" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>

      <v-flex xs12 class="text-center" style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'h2' : 'h1'">Bem-vindo</p>

        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.bemvindo"></p>
      </v-flex>

      <v-flex xs12 :style="`height: ${$vuetify.breakpoint.xs ? '80px' : '60px'};`"></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    mossoo() {
      return process.env.VUE_APP_URL_API + `arquivos/BemVindo.mp4`;
    }
  }
};
</script>
<style scoped>
.video-fullscreen {
  width: 70vw;
  height: 70vh;
  object-fit: cover;
  display: block;
}
</style>
